module.exports = __webpack_public_path__ + "static/media/1@1280w.fd484a68.jpg";